const defaultSettings = {
  acceptRequired: false,
  isAcceptedByDefault: false
};
export const getTermsAndConditionsSettings = clientData => {
  if (!(clientData != null && clientData.termsAndConditionsSettings)) {
    return defaultSettings;
  }
  try {
    const _ref = JSON.parse(clientData.termsAndConditionsSettings),
      acceptRequired = _ref.acceptRequired,
      isAcceptedByDefault = _ref.isAcceptedByDefault;
    return {
      acceptRequired: acceptRequired ?? defaultSettings.acceptRequired,
      isAcceptedByDefault: isAcceptedByDefault ?? defaultSettings.isAcceptedByDefault
    };
  } catch {
    return defaultSettings;
  }
};
//# sourceMappingURL=get-terms-and-conditions-settings.js.map